<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter109">
<p class="centerImage"><img alt="images" id="img20" src="images/img20.jpg"/></p>
<p class="caption">Captain Norm Rosholt was shot down on his thirty-first mission and taken prisoner. <em class="italic">Rosholt</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_Chapter109.vue?d19962a4